<template>
  <div>
    <el-card shadow="hover">
      <template v-if="!embedded" slot="header">
        <span>审批管理</span>
      </template>

      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item v-if="!embedded" label="客户名称">
          <el-input v-model="searchForm.customerName" placeholder="请输入客户名称" clearable style="width: 180px" @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="全部" clearable style="width: 140px" @change="handleSearch">
            <el-option v-for="s in statusOptions" :key="s.value" :label="s.label" :value="s.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库类型">
          <el-select v-model="searchForm.outboundType" placeholder="全部" clearable style="width: 160px" @change="handleSearch">
            <el-option v-for="t in outboundTypes" :key="t" :label="t" :value="t"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货类型">
          <el-select v-model="searchForm.stockType" placeholder="全部" clearable style="width: 130px" @change="handleSearch">
            <el-option label="普通存货" value="普通存货"></el-option>
            <el-option label="品鉴存货" value="品鉴存货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="礼品类型">
          <el-select v-model="searchForm.giftTypeId" placeholder="全部" clearable style="width: 140px" @change="handleSearch">
            <el-option v-for="t in giftTypeOptions" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" style="width: 100%" stripe size="small" border row-key="id" :expand-row-keys="expandedKeys">
        <el-table-column type="expand" width="40" :fixed="embedded ? false : 'left'">
          <template slot-scope="props">
            <div class="detail-panel">
              <div class="detail-panel-title"><i class="el-icon-info"></i><span>申请详情</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">申请ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                  <div class="dc-cell"><span class="dc-label">申请单号</span><span class="dc-value">{{ props.row.applicationNo || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">客户</span><span class="dc-value">{{ props.row.customerName || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">业务员</span><span class="dc-value">{{ props.row.userName || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">出库类型</span>
                    <el-tag :type="outTypeTag(props.row)" :class="outTypeClass(props.row.outboundType)" size="mini">{{ vipCardLabel(props.row) || '-' }}</el-tag>
                  </div>
                  <!-- 仅出库类型为试用时展示：试用类型与核验凭证 -->
                  <template v-if="['产品试用', '试用'].includes(props.row.outboundType || props.row.cardName)">
                    <div class="dc-cell"><span class="dc-label">试用类型</span><span class="dc-value">{{ props.row.applicableTypeName || '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">核验方式/凭证</span>
                      <span class="dc-value">
                        <template v-if="props.row.verificationType === 1">
                          <el-tag size="mini" type="success" effect="plain"><i class="el-icon-mobile-phone"></i> 短信验证</el-tag>
                          <span v-if="props.row.verifyPhone" style="color:#409EFF;margin-left:6px;font-size:12px;font-weight:600">({{ props.row.verifyPhone }})</span>
                        </template>
                        <template v-else-if="props.row.verificationType === 2">
                          <el-tag size="mini" type="warning" effect="plain">特殊通道</el-tag>
                          <span v-if="props.row.attachmentUrl" style="margin-left:6px;display:inline-flex;align-items:center">
                            <el-image
                              v-if="isImageFile(props.row.attachmentUrl)"
                              style="width: 22px; height: 22px; border-radius: 2px; vertical-align: middle;"
                              :src="full(props.row.attachmentUrl)"
                              :preview-src-list="[full(props.row.attachmentUrl)]"
                            ></el-image>
                            <el-button
                              v-else
                              size="mini"
                              type="primary"
                              plain
                              icon="el-icon-download"
                              style="padding: 2px 6px; font-size: 11px; margin-left: 2px;"
                              @click="downloadAttachment(props.row.attachmentUrl)"
                            >
                              下载凭证
                            </el-button>
                          </span>
                          <span v-else class="muted" style="margin-left:4px;font-size:12px">（无凭证）</span>
                        </template>
                        <template v-else-if="props.row.verificationType === 3">
                          <el-tag size="mini" type="info" effect="plain">免核验</el-tag>
                        </template>
                        <template v-else>-</template>
                      </span>
                    </div>
                  </template>
                  <!-- 仅出库类型为礼品/损耗等礼品类时展示：礼品类型 -->
                  <template v-if="isGiftOutboundType(props.row.cardName || props.row.outboundType, props.row) || props.row.applicableTypeName">
                    <div class="dc-cell"><span class="dc-label">礼品类型</span><span class="dc-value">{{ props.row.applicableTypeName || '-' }}</span></div>
                  </template>
                  <!-- <div class="dc-cell"><span class="dc-label">出库日期</span><span class="dc-value">{{ props.row.outboundDate || '-' }}</span></div> -->
                  <!-- <div class="dc-cell"><span class="dc-label">送货人</span><span class="dc-value">{{ props.row.sender || '-' }}</span></div> -->
                  <div class="dc-cell"><span class="dc-label">商品数量合计</span><span class="dc-value">{{ props.row.totalQuantity || 0 }}</span></div>
                  <div class="dc-cell"><span class="dc-label">状态</span>
                    <el-tag :type="statusTag(props.row.outboundType, props.row.status)" size="mini">{{ statusLabel(props.row.outboundType, props.row.status) }}</el-tag>
                  </div>
                  <div class="dc-cell"><span class="dc-label">申请时间</span><span class="dc-value">{{ formatDate(props.row.outboundDate, 10) || formatDate(props.row.createTime, 10) || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">审批时间</span><span class="dc-value">{{ formatDate(props.row.approveTime, 10) || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">出库时间</span><span class="dc-value">{{ [0, 2, 6].includes(Number(props.row.status)) ? '-' : (formatDate(props.row.finishTime, 10) || '-') }}</span></div>
                  <div class="dc-cell w4"><span class="dc-label">生产批次</span><span class="dc-value" style="white-space:pre-line">{{ props.row.batchNos || '-' }}</span></div>
                  <div class="dc-cell w4"><span class="dc-label">商品列表</span><span class="dc-value">{{ prodNamesQty(props.row) || '-' }}</span></div>
                  <div class="dc-cell w4"><span class="dc-label">申请备注</span><span class="dc-value">{{ props.row.remark || '-' }}</span></div>
                  <div class="dc-cell w4"><span class="dc-label">审核备注</span><span class="dc-value">
                    <template v-if="props.row.approveRemark">
                      <span v-if="proxyPrefix(props.row.approveRemark)" style="color:#E62412;font-weight:700">{{ proxyPrefix(props.row.approveRemark) }}</span>{{ proxyBody(props.row.approveRemark) || (proxyPrefix(props.row.approveRemark) ? '' : props.row.approveRemark) }}
                    </template>
                    <template v-else>-</template>
                  </span></div>
                  <div class="dc-cell w4" v-if="props.row.rejectRemark"><span class="dc-label">驳回原因</span><span class="dc-value" style="color:#f56c6c">{{ props.row.rejectRemark }}</span></div>
                  <div class="dc-cell w4" v-if="props.row.outboundRemark"><span class="dc-label">出库备注</span><span class="dc-value">{{ props.row.outboundRemark }}</span></div>
                  <div class="dc-cell w4" v-if="props.row.images"><span class="dc-label">图片</span>
                    <div class="img-list">
                      <el-image v-for="(img, idx) in splitImages(props.row.images)" :key="idx"
                                :src="full(img)" :preview-src-list="splitImages(props.row.images).map(full)"
                                style="width:60px;height:60px;margin-right:6px;border-radius:4px"></el-image>
                    </div>
                  </div>
                  <div class="dc-cell w4" v-if="props.row.signature"><span class="dc-label">拍照签名</span>
                    <el-image :src="full(props.row.signature)" :preview-src-list="[full(props.row.signature)]"
                              style="width:120px;height:60px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
        <el-table-column v-if="!embedded" prop="applicationNo" label="申请单号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="出库类型" min-width="150">
          <template slot-scope="s">
            <el-tag :type="outTypeTag(s.row)" :class="outTypeClass(s.row.outboundType)" size="mini">{{ vipCardLabel(s.row) || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="商品列表" min-width="220" show-overflow-tooltip>
          <!-- 客户详情页内嵌时列表只显产品名不带数量（展开行仍带）；独立页照常带数量 -->
          <template slot-scope="s">{{ (embedded ? prodNames(s.row) : prodNamesQty(s.row)) || '-' }}</template>
        </el-table-column>
        <el-table-column label="商品数量合计" width="120" align="center">
          <template slot-scope="s">{{ s.row.totalQuantity || 0 }}</template>
        </el-table-column>
        <el-table-column prop="userName" label="业务员" width="110"></el-table-column>
        <el-table-column label="审核员" width="100">
          <template slot-scope="s">{{ s.row.approverName || '-' }}</template>
        </el-table-column>
        <el-table-column label="审批时间" width="110">
          <template slot-scope="s">{{ formatDate(s.row.approveTime, 10) || '-' }}</template>
        </el-table-column>
        <el-table-column label="出库时间" width="110">
          <template slot-scope="s">{{ [0, 2, 6].includes(Number(s.row.status)) ? '-' : (formatDate(s.row.finishTime, 10) || '-') }}</template>
        </el-table-column>
        <el-table-column label="生产批次" min-width="140" show-overflow-tooltip>
          <template slot-scope="s">{{ s.row.batchNos || '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="160">
          <template slot-scope="s">
            <el-tag :type="statusTag(s.row.outboundType, s.row.status)"
                    :effect="s.row.outboundType === '新出库' && Number(s.row.status) === 4 ? 'dark' : 'light'"
                    :class="{ 'newout-uncompleted-tag': s.row.outboundType === '新出库' && Number(s.row.status) === 4 }"
                    size="mini">{{ statusLabel(s.row.outboundType, s.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="申请ID" width="80"></el-table-column>
        <el-table-column label="操作" width="290" :fixed="embedded ? false : 'right'" align="center">
          <template slot-scope="s">
            <el-button v-if="$hasPerm('func:approval:approve')" size="mini" :type="Number(s.row.status) === 0 ? 'success' : 'info'"
                       icon="el-icon-check" :disabled="Number(s.row.status) !== 0"
                       @click="handleApprove(s.row)">通过</el-button>
            <el-button v-if="$hasPerm('func:approval:approve')" size="mini" :type="Number(s.row.status) === 0 ? 'danger' : 'info'"
                       icon="el-icon-close" :disabled="Number(s.row.status) !== 0"
                       @click="handleReject(s.row)">驳回</el-button>
            <el-button v-if="$hasPerm('func:approval:delete')" size="mini" type="danger" plain icon="el-icon-delete"
                       @click="handleDelete(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; loadList() }"
          @current-change="p => { currentPage = p; loadList() }"
          :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>

    <!-- 详情抽屉 -->
    <el-drawer title="申请详情" :visible.sync="detailVisible" size="640px" direction="rtl">
      <div v-if="detail" style="padding: 0 20px">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="申请单号">{{ detail.applicationNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="statusTag(detail.outboundType, detail.status)" size="mini">{{ statusLabel(detail.outboundType, detail.status) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="客户">{{ detail.customerName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="业务员">{{ detail.userName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="出库类型">
            <el-tag :type="outTypeTag(detail)" :class="outTypeClass(detail.outboundType)" size="mini">{{ vipCardLabel(detail) || '-' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item v-if="['产品试用', '试用'].includes(detail.outboundType || detail.cardName)" label="试用类型">
            {{ detail.applicableTypeName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item v-if="isGiftOutboundType(detail.outboundType || detail.cardName, detail) || detail.applicableTypeName" label="礼品类型">
            {{ detail.applicableTypeName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item v-if="['产品试用', '试用'].includes(detail.outboundType || detail.cardName)" label="核验方式/凭证">
            <template v-if="detail.verificationType === 1">
              <el-tag size="mini" type="success" effect="plain"><i class="el-icon-mobile-phone"></i> 短信验证</el-tag>
              <span v-if="detail.verifyPhone" style="color:#409EFF;margin-left:6px;font-weight:600">({{ detail.verifyPhone }})</span>
            </template>
            <template v-else-if="detail.verificationType === 2">
              <el-tag size="mini" type="warning" effect="plain">特殊通道</el-tag>
              <span v-if="detail.attachmentUrl" style="margin-left:8px;display:inline-flex;align-items:center">
                <el-image
                  v-if="isImageFile(detail.attachmentUrl)"
                  style="width: 28px; height: 28px; border-radius: 4px; vertical-align: middle"
                  :src="full(detail.attachmentUrl)"
                  :preview-src-list="[full(detail.attachmentUrl)]"
                ></el-image>
                <el-button
                  v-else
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-download"
                  style="padding: 3px 8px; font-size: 11px; margin-left: 4px;"
                  @click="downloadAttachment(detail.attachmentUrl)"
                >
                  下载凭证
                </el-button>
              </span>
              <span v-else class="muted" style="margin-left:6px">（未上传凭证）</span>
            </template>
            <template v-else-if="detail.verificationType === 3">
              <el-tag size="mini" type="info" effect="plain">免核验</el-tag>
            </template>
            <template v-else>-</template>
          </el-descriptions-item>
          <el-descriptions-item label="出库日期">{{ detail.outboundDate || '-' }}</el-descriptions-item>
          <!-- <el-descriptions-item label="送货人">{{ detail.sender || '-' }}</el-descriptions-item> -->
          <el-descriptions-item label="申请时间">{{ formatDate(detail.outboundDate, 10) || formatDate(detail.createTime, 10) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审批时间">{{ formatDate(detail.approveTime, 10) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="完结时间">{{ formatDate(detail.finishTime) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请备注" :span="2">{{ detail.remark || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核备注" :span="2">
            <template v-if="detail.approveRemark">
              <span v-if="proxyPrefix(detail.approveRemark)" style="color:#E62412;font-weight:700">{{ proxyPrefix(detail.approveRemark) }}</span>{{ proxyBody(detail.approveRemark) || (proxyPrefix(detail.approveRemark) ? '' : detail.approveRemark) }}
            </template>
            <template v-else>-</template>
          </el-descriptions-item>
          <el-descriptions-item label="驳回原因" :span="2">
            <template v-if="detail.rejectRemark">
              <span v-if="proxyPrefix(detail.rejectRemark)" style="color:#E62412;font-weight:700">{{ proxyPrefix(detail.rejectRemark) }}</span><span :style="proxyBody(detail.rejectRemark) ? 'color:#f56c6c' : ''">{{ proxyBody(detail.rejectRemark) || (proxyPrefix(detail.rejectRemark) ? '' : detail.rejectRemark) }}</span>
            </template>
            <template v-else>-</template>
          </el-descriptions-item>
        </el-descriptions>

        <div class="section-title">商品明细</div>
        <el-table v-if="detail.details && detail.details.length" :data="detail.details" size="mini" border>
          <el-table-column label="商品" min-width="140">
            <template slot-scope="sc">{{ prodName(detail, sc.row.productName) || '-' }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
          <el-table-column prop="batchNo" label="批次" width="120">
            <template slot-scope="s">{{ s.row.batchNo || '-' }}</template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        </el-table>
        <div v-else class="muted small">无商品明细</div>

        <div v-if="detail.images" class="section-title">附件照片</div>
        <div v-if="detail.images" class="img-list">
          <el-image v-for="(url, i) in (detail.images || '').split(',').filter(Boolean)"
                    :key="i" :src="full(url)" :preview-src-list="(detail.images || '').split(',').filter(Boolean).map(full)"
                    style="width:96px;height:96px;border-radius:4px;margin:0 8px 8px 0"></el-image>
        </div>

        <div v-if="detail.status === 0" class="footer-actions">
          <el-button v-if="$hasPerm('func:approval:approve')" type="success" @click="handleApprove(detail); detailVisible = false">通过</el-button>
          <el-button v-if="$hasPerm('func:approval:approve')" type="danger" @click="handleReject(detail); detailVisible = false">驳回</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 通过：审批时间 -->
    <el-dialog title="通过申请" :visible.sync="approveVisible" width="880px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="approveForm" label-width="90px" size="small">
        <el-form-item label="申请单号">
          <el-input :value="approveForm.applicationNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="审批时间" required>
          <el-date-picker v-model="approveForm.approveDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="出库时间">
          <el-date-picker v-model="approveForm.dispatchDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期（礼品/试用通过即出库时生效）" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item v-for="(b, i) in approveForm.batches" :key="b.productId" label="生产批次">
          <div style="font-size:12px;color:#909399;line-height:1.4;margin-bottom:6px">
            {{ b.productName }} <span style="color:#303133">（申请 {{ b.quantity }}）</span>
          </div>
          <div v-for="(s, si) in b.splits" :key="si" style="display:flex;gap:8px;align-items:center;margin-bottom:6px">
            <el-select v-model="s.batchNo" filterable clearable placeholder="选择批次" size="small" style="flex:1">
              <el-option v-for="opt in b.options" :key="opt.batchNo" :label="opt.batchNo + '(剩 ' + opt.remainingQuantity + ')'"
                         :value="opt.batchNo" :disabled="Number(opt.remainingQuantity || 0) <= 0"></el-option>
            </el-select>
            <el-input-number v-model="s.qty" :min="0" :precision="0" controls-position="right" size="small" style="width:130px"></el-input-number>
            <el-button v-if="b.splits.length > 1" size="mini" type="text" icon="el-icon-delete" style="color:#f56c6c" @click="removeBatchSplit(i, si)">删除</el-button>
          </div>
          <el-button class="white-text-btn" size="mini" type="primary" plain icon="el-icon-plus" @click="addBatchSplit(i)">添加批次</el-button>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="approveForm.remark" type="textarea" :rows="2" maxlength="200" show-word-limit placeholder="请输入备注（可选）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="approveVisible = false">取消</el-button>
        <el-button size="small" type="success" @click="confirmApprove" :loading="submitting">确认通过</el-button>
      </div>
    </el-dialog>

    <!-- 驳回原因 -->
    <el-dialog title="驳回申请" :visible.sync="rejectVisible" width="480px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="rejectForm" label-width="80px" size="small">
        <el-form-item label="审批时间" required>
          <el-date-picker v-model="rejectForm.approveDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="驳回原因">
          <el-input v-model="rejectForm.remark" type="textarea" :rows="3" placeholder="请输入驳回原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="rejectVisible = false">取消</el-button>
        <el-button size="small" type="danger" @click="confirmReject" :loading="submitting">确认驳回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { outboundApi, inventoryApi } from '../api/api'

export default {
  name: 'ApprovalManagement',
  props: {
    embeddedCustomer: { type: Object, default: null }
  },
  data() {
    return {
      list: [],
      searchForm: { status: null, outboundType: '', stockType: '', giftTypeId: '', customerName: '' },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      statusOptions: [
        { value: 0, label: '审核中' },
        { value: 2, label: '已驳回' },
        { value: 1, label: '待签字' },
        { value: 3, label: '已完结' },
        { value: 4, label: '未完结' },
        { value: 6, label: '已撤销' }
      ],
      allOutboundTypes: [],
      giftTypeOptions: [],
      outboundTypes: ['礼品', '试用', '送存货', '尊贵卡A', '尊贵卡B', '尊贵卡C', '新出库'],
      detailVisible: false,
      detail: null,
      rejectVisible: false,
      rejectForm: { id: null, remark: '', approveDate: '' },
      expandedKeys: [],
      approveVisible: false,
      approveForm: { id: null, applicationNo: '', approveDate: '', dispatchDate: '', batches: [], remark: '' },
      submitting: false
    }
  },
  computed: {
    embedded() { return !!(this.embeddedCustomer && this.embeddedCustomer.id) }
  },
  mounted() {
    this.loadList()
    this.loadOutboundTypes()
    this.loadGiftTypes()
    // 监听出库管理修改欠款/状态后同步刷新
    this._onDebtChanged = () => this.loadList()
    window.addEventListener('outbound-debt-changed', this._onDebtChanged)
  },
  beforeDestroy() {
    if (this._onDebtChanged) window.removeEventListener('outbound-debt-changed', this._onDebtChanged)
  },
  methods: {
    isHistoryReplenishment(row) {
      if (!row) return false
      const cardName = String(row.cardName || row.outboundType || '').trim()
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C', '尊贵卡a', '尊贵卡b', '尊贵卡c'].includes(cardName)) return false
      if (row.isHistoryReplenishment == true || row.isHistoryReplenishment === 'true' || row.isHistoryReplenishment === 1) return true
      const appTime = row.applicationTime || row.outboundDate || row.createTime
      const actualTime = row.orderActualUpdateTime || row.actualUpdateTime
      if (!appTime) return false
      const appStr = String(appTime).replace('T', ' ')
      const winStartStr = String(row.serviceFeeStartDate || '').slice(0, 10)
      if (winStartStr && appStr.slice(0, 10) < winStartStr) return true
      if (actualTime && !cardName.toUpperCase().includes('A') && appStr < String(actualTime).replace('T', ' ')) return true
      return false
    },
    historyReplenishmentRemarkNote(row) {
      if (!row || !this.isHistoryReplenishment(row)) return ''
      const cardName = String(row.cardName || row.outboundType || '').trim()
      const appTime = row.applicationTime || row.outboundDate || row.createTime
      const actualTime = row.orderActualUpdateTime || row.actualUpdateTime
      const isCardA = cardName.toUpperCase().includes('A')
      const winStartStr = String(row.serviceFeeStartDate || '').slice(0, 10)
      const appStr = String(appTime || '').replace('T', ' ')

      if (isCardA) {
        const applyFmt = String(appTime || '').slice(0, 10)
        return `申请时间（${applyFmt}）属于过去的服务年度${winStartStr ? '（早于本年度起点 ' + winStartStr + '）' : ''}，属于跨年历史补录。保存后【不会扣除】本年度的剩余可领取数量。`
      }
      const applyFmt = String(appTime || '').replace('T', ' ').slice(0, 16)
      if (actualTime && !isCardA && appStr <= String(actualTime).replace('T', ' ')) {
        const actualFmt = String(actualTime).replace('T', ' ').slice(0, 16)
        const wordUnit = cardName.toUpperCase().includes('B') ? '应该剩余额度' : '应该剩余'
        return `申请时间（${applyFmt}）早于实际剩余设置时间（${actualFmt}），属于本年度历史补录。保存后【只扣除${wordUnit}】，【不扣除实际剩余】。`
      }
      if (winStartStr && appStr.slice(0, 10) < winStartStr) {
        return `申请时间（${applyFmt}）属于过去的服务年度${winStartStr ? '（早于本年度起点 ' + winStartStr + '）' : ''}，属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
      }
      return `申请时间（${applyFmt}）属于过去的服务年度，属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
    },
    // 「超级管理员XXX代为审核」前缀切割：拆出来后让前缀在视觉上单独标红
    proxyPrefix(t) { const m = String(t == null ? '' : t).match(/^【超级管理员.+?代为审核】/); return m ? m[0] : '' },
    proxyBody(t) { return String(t == null ? '' : t).replace(/^【超级管理员.+?代为审核】/, '') },
    loadOutboundTypes() {
      axios.get('/outbound-type/list').then(res => {
        const list = Array.isArray(res.data) ? res.data : []
        this.allOutboundTypes = list.filter(t => t.enabled !== 0)
      }).catch(() => { this.allOutboundTypes = [] })
    },
    loadGiftTypes() {
      axios.get('/gift-type/list', { params: { enabled: 1 } }).then(res => {
        this.giftTypeOptions = Array.isArray(res.data) ? res.data : []
      }).catch(() => { this.giftTypeOptions = [] })
    },
    isGiftOutboundType(typeName, row) {
      if (!typeName) return false
      const str = String(typeName).trim()
      if (str === '礼品' || str.startsWith('礼品·')) return true
      // 1. 动态匹配已配置的出库类型（categoryId === 1 为礼品大类）
      if (this.allOutboundTypes && this.allOutboundTypes.length) {
        const match = this.allOutboundTypes.find(t => t && t.name === str)
        if (match && Number(match.categoryId) === 1) return true
      }
      // 2. 检查 row 的 applicableTypeName / applicableTypeId 是否在礼品类型列表中
      if (row && (row.applicableTypeId || row.applicableTypeName)) {
        if (this.giftTypeOptions && this.giftTypeOptions.length) {
          if (this.giftTypeOptions.some(g => g.id === row.applicableTypeId || g.name === row.applicableTypeName)) {
            return true
          }
        }
      }
      // 3. 兜底内置常见礼品出库类型名称
      if (['损耗', '试喝', '赠送', '过期'].includes(str)) return true
      return false
    },
    vipCardLabel(category, cardSeq, applicableTypeName) {
      let stockType = null
      let rawRow = null
      if (category && typeof category === 'object') {
        rawRow = category
        stockType = category.stockType
        applicableTypeName = category.applicableTypeName
        cardSeq = category.cardSeq
        category = category.outboundType || category.cardName || category.category
      }
      if (!category) return ''
      if (category === '送存货') {
        if (stockType === '品鉴存货' || stockType === '试用存货' || applicableTypeName) {
          return (applicableTypeName && String(applicableTypeName).trim())
            ? ('品鉴存货·' + String(applicableTypeName).trim())
            : (stockType || '品鉴存货')
        }
        return stockType || '普通存货'
      }
      if (category === '产品试用' || category === '试用') {
        return (applicableTypeName && String(applicableTypeName).trim()) ? String(applicableTypeName).trim() : '试用'
      }
      // 礼品大类或礼品分类下的动态出库类型（损耗、试喝、赠送、过期或后台新增类型）
      if (this.isGiftOutboundType(category, rawRow)) {
        const subType = (applicableTypeName && String(applicableTypeName).trim()) || ''
        const cleanName = String(category).replace(/^礼品[·\s]*/, '')
        if (!cleanName || cleanName === '礼品') {
          return subType ? `礼品·${subType}` : '礼品'
        }
        return subType ? `礼品·${subType}·${cleanName}` : `礼品·${cleanName}`
      }
      const isVip = category === '尊贵卡A' || category === '尊贵卡B' || category === '尊贵卡C'
      if (!isVip) return category
      if (cardSeq == null || cardSeq === '') return category
      return category + cardSeq
    },
    loadList() {
      const params = {}
      // 嵌入模式：锁定该客户，仍可叠加状态/出库类型搜索
      if (this.embedded) params.customerId = this.embeddedCustomer.id
      if (this.searchForm.status !== null && this.searchForm.status !== '') params.status = this.searchForm.status
      if (this.searchForm.outboundType) params.outboundType = this.searchForm.outboundType
      if (this.searchForm.stockType) params.stockType = this.searchForm.stockType
      if (this.searchForm.giftTypeId !== '' && this.searchForm.giftTypeId !== null) params.giftTypeId = this.searchForm.giftTypeId
      if (!this.embedded && this.searchForm.customerName && this.searchForm.customerName.trim()) params.customerName = this.searchForm.customerName.trim()
      outboundApi.getOutboundPage(this.currentPage, this.pageSize, params).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || this.list.length
        // 嵌入模式每行默认收起，需要时再点开
      })
    },
    handleSearch() { this.currentPage = 1; this.loadList() },
    resetSearch() { this.searchForm = { status: null, outboundType: '', stockType: '', giftTypeId: '', customerName: '' }; this.handleSearch() },
    indexMethod(index) {
      return this.total - ((this.currentPage - 1) * this.pageSize + index)
    },
    openDetail(row) {
      outboundApi.getOutboundById(row.id).then(res => {
        this.detail = res.data || null
        this.detailVisible = true
      })
    },
    handleApprove(row) {
      const outboundType = row.outboundType || ''
      this.approveForm = {
        id: row.id,
        applicationNo: row.applicationNo || '',
        outboundType,
        approveDate: new Date().toISOString().slice(0, 10),
        dispatchDate: new Date().toISOString().slice(0, 10),
        batches: [],
        remark: ''
      }
      this.approveVisible = true
      // 礼品不需要选生产批次，直接跳过明细+批次加载
      if (outboundType === '礼品') return
      // 列表行不含明细，按 id 拉取该申请明细，再按产品构建生产批次下拉（支持多批次拆分）
      outboundApi.getOutboundById(row.id).then(res => {
        const detail = res.data || {}
        const details = Array.isArray(detail.details) ? detail.details
                      : (Array.isArray(detail.items) ? detail.items : [])
        const seen = {}
        const batches = []
        details.forEach(d => {
          const pid = d.productId
          if (pid == null || seen[pid]) return
          seen[pid] = true
          const qty = Number(d.quantity || d.qty || 0)
          batches.push({
            productId: pid,
            productName: d.productName || ('产品#' + pid),
            quantity: qty,
            options: [],
            splits: [{ batchNo: '', qty: qty }]
          })
        })
        this.approveForm.batches = batches
        batches.forEach((b, i) => {
          inventoryApi.getBatches(b.productId).then(r => {
            // 后端已返回 [{batchNo, remainingQuantity}]；兼容老 List<String>
            const raw = Array.isArray(r.data) ? r.data : []
            const opts = raw.map(x => typeof x === 'string'
              ? { batchNo: x, remainingQuantity: 0 }
              : { batchNo: x.batchNo, remainingQuantity: Number(x.remainingQuantity || 0) })
            this.$set(this.approveForm.batches[i], 'options', opts)
          }).catch(() => {})
        })
      }).catch(() => {})
    },
    addBatchSplit(i) {
      const b = this.approveForm.batches[i]
      if (!b) return
      b.splits.push({ batchNo: '', qty: 0 })
      this.$set(this.approveForm.batches, i, Object.assign({}, b))
    },
    removeBatchSplit(i, si) {
      const b = this.approveForm.batches[i]
      if (!b || b.splits.length <= 1) return
      b.splits.splice(si, 1)
      this.$set(this.approveForm.batches, i, Object.assign({}, b))
    },
    confirmApprove() {
      if (!this.approveForm.approveDate) { this.$message.warning('请选择审批时间'); return }
      const payload = []
      for (const b of (this.approveForm.batches || [])) {
        const cleaned = (b.splits || []).filter(s => s.batchNo && Number(s.qty) > 0)
        if (!cleaned.length) continue
        const sum = cleaned.reduce((s, x) => s + Number(x.qty || 0), 0)
        if (sum !== Number(b.quantity || 0)) {
          this.$message.warning(`${b.productName} 批次合计 ${sum} ≠ 申请 ${b.quantity}`); return
        }
        for (const s of cleaned) {
          const opt = (b.options || []).find(o => o.batchNo === s.batchNo)
          const rem = opt ? Number(opt.remainingQuantity || 0) : 0
          if (Number(s.qty) > rem) {
            this.$message.warning(`${b.productName} 批次 ${s.batchNo} 剩 ${rem}，超出选择的 ${s.qty}`); return
          }
        }
        payload.push({
          productId: b.productId,
          batchNo: cleaned[0].batchNo,
          batchSplit: cleaned.map(s => ({ batchNo: s.batchNo, qty: Number(s.qty) }))
        })
      }
      this.submitApprove(this.approveForm.id, 1, this.approveForm.remark || '', this.approveForm.approveDate, payload, this.approveForm.dispatchDate)
    },
    handleReject(row) {
      this.rejectForm = { id: row.id, remark: '', approveDate: new Date().toISOString().slice(0, 10) }
      this.rejectVisible = true
    },
    handleDelete(row) {
      this.$confirm('确定删除该记录？仅从列表中删除此条记录，不涉及任何库存或额度变动，删除后不可恢复。', '提示', { type: 'warning' }).then(() => {
        outboundApi.deleteOutbound(row.id).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '删除失败')
          }
        })
      }).catch(() => {})
    },
    confirmReject() {
      if (!this.rejectForm.approveDate) { this.$message.warning('请选择审批时间'); return }
      if (!this.rejectForm.remark.trim()) {
        this.$message.warning('请输入驳回原因')
        return
      }
      this.submitApprove(this.rejectForm.id, 2, this.rejectForm.remark, this.rejectForm.approveDate)
    },
    submitApprove(id, status, remark, approveDate, batches, dispatchDate) {
      this.submitting = true
      outboundApi.approveOutbound(id, status, remark, approveDate, batches, dispatchDate).then(res => {
        if (res.data && res.data.success) {
          this.$message.success(status === 1 ? '已通过' : '已驳回')
          this.rejectVisible = false
          this.approveVisible = false
          this.loadList()
        } else {
          this.$message.error((res.data && res.data.message) || '操作失败')
        }
      }).finally(() => { this.submitting = false })
    },
    // 仅前端展示：尊贵卡类出库的产品名加"尊贵卡-"前缀（已带前缀则不重复加）
    vipName(name, type) {
      if (!name) return name
      if (!(type && String(type).startsWith('尊贵卡'))) return name
      return String(name).startsWith('尊贵卡-') ? name : ('尊贵卡-' + name)
    },
    vipNames(joined, type) {
      if (!joined || !(type && String(type).startsWith('尊贵卡'))) return joined
      return String(joined).split(/[,，、]\s*/).filter(s => s !== '')
        .map(s => s.startsWith('尊贵卡-') ? s : ('尊贵卡-' + s)).join('、')
    },
    // 尊贵卡B 明细产品名集合（后端按客户尊贵卡B订单明细下发）
    _vipBSet(row) {
      const set = {}
      const raw = row && row.vipBDetailNames
      if (raw) String(raw).split(/[,，、]\s*/).forEach(x => { const t = (x || '').trim(); if (t) set[t] = true })
      return set
    },
    // 商品名串：尊贵卡B 仅给在该客户尊贵卡B明细里的产品加前缀；A/C 整体加；已带前缀则不重复加
    prodNames(row) {
      const joined = row && row.productNames
      const type = row && row.outboundType
      if (!joined) return joined
      if (type === '尊贵卡B') {
        const set = this._vipBSet(row)
        return String(joined).split(/[,，、]\s*/).filter(s => s !== '')
          .map(s => (set[s] && !s.startsWith('尊贵卡-')) ? ('尊贵卡-' + s) : s).join('、')
      }
      return this.vipNames(joined, type)
    },
    // 商品列表带数量："产品×数量、产品×数量"；前缀复用 prodNames（按类型）；无 productNamesQty 回落纯名字
    prodNamesQty(row) {
      const raw = row && row.productNamesQty
      if (!raw) return this.prodNames(row) || '-'
      return String(raw).split(/[,，、]\s*/).filter(s => s !== '').map(seg => {
        const m = String(seg).match(/^(.*)×(\d+)$/)
        if (!m) return this.prodNames(Object.assign({}, row, { productNames: seg }))
        return this.prodNames(Object.assign({}, row, { productNames: m[1] })) + '×' + m[2]
      }).join('、')
    },
    // 单个商品名（详情商品明细），row 为含 outboundType/vipBDetailNames 的对象
    prodName(row, name) {
      if (!name) return name
      const type = row && row.outboundType
      if (type === '尊贵卡B') {
        const set = this._vipBSet(row)
        return set[String(name).trim()] ? (String(name).startsWith('尊贵卡-') ? name : ('尊贵卡-' + name)) : name
      }
      return this.vipName(name, type)
    },
    // 与「普通订单 / 尊贵卡订单」页保持一致：状态文案随类型变化
    // （礼品/试用不签字，1=已通过、5=待出库；新出库 4=未完结）
    statusLabel(type, s) {
      const isGiftOrTrial = type === '礼品' || type === '试用'
      const m = {
        0: '审核中',
        1: isGiftOrTrial ? '待出库' : '待签字',
        2: '已驳回',
        3: '已完结',
        4: '未完结',
        5: isGiftOrTrial ? '待出库' : '已签字（待出库）',
        6: '已撤销'
      }
      return m[s] != null ? m[s] : s
    },
    statusTag(type, s) {
      // 新出库 + 未完结 → 红色醒目
      if (type === '新出库' && Number(s) === 4) return 'danger'
      const m = { 0: 'warning', 1: 'primary', 2: 'danger', 3: 'success', 4: 'info', 5: 'warning', 6: 'info' }
      return m[s] || ''
    },
    // 新出库欠款：优先 row.debt；为空回落 row.totalAmount（仅展示）
    getDebtForRow(row) {
      if (row.debt != null && row.debt !== '') return Number(row.debt) || 0
      if (row.totalAmount != null) return Number(row.totalAmount) || 0
      return 0
    },
    outTypeTag(t) {
      let rawRow = null
      if (t && typeof t === 'object') {
        rawRow = t
        t = t.outboundType || t.cardName || t.category
      }
      if (t === '送存货' || t === '普通存货' || t === '品鉴存货' || t === '试用存货') return 'warning'
      if (this.isGiftOutboundType(t, rawRow)) return 'danger'
      if (t === '试用' || t === '产品试用') return 'success'
      if (t === '新出库') return 'info'
      if (t === '尊贵卡A') return 'warning' // tag-vip-a 覆盖为金
      if (t === '尊贵卡B') return 'primary'
      if (t === '尊贵卡C') return 'info'    // tag-vip-c 覆盖为紫
      return ''
    },
    outTypeClass(t) {
      if (t === '尊贵卡A') return 'tag-vip-a'
      if (t === '尊贵卡B') return 'tag-vip-b'
      if (t === '尊贵卡C') return 'tag-vip-c'
      if (t === '新出库') return 'tag-newout'
      return ''
    },
    isImageFile(url) {
      if (!url) return false
      return /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url)
    },
    full(url) {
      if (!url) return ''
      if (/^(https?:|data:)/i.test(url)) return url
      const base = (axios.defaults.baseURL || '').replace(/\/api\/?$/, '')
      return base + url
    },
    downloadAttachment(url) {
      if (!url) return
      const downloadApiUrl = '/api/file/download?url=' + encodeURIComponent(url)
      window.open(downloadApiUrl, '_blank')
    },
    formatDate(v, len) { return v ? String(v).replace('T', ' ').slice(0, typeof len === 'number' ? len : 19) : '' }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; text-align: right; }
.muted { color: #909399; font-size: 12px; }
.small { font-size: 12px; }
.section-title { margin: 16px 0 8px; font-size: 13px; font-weight: 600; color: #303133; }
.img-list { display: flex; flex-wrap: wrap; }
.footer-actions { margin-top: 18px; display: flex; gap: 12px; justify-content: flex-end; }

.detail-panel { padding: 14px 24px 18px; background: linear-gradient(180deg,#fafcff 0%,#f5f7fa 100%); border-top: 1px dashed #dcdfe6; }
.detail-panel-title { display: flex; align-items: center; gap: 6px; color: #303133; font-size: 13px; font-weight: 600; margin: 4px 0 12px; }
.detail-panel-title i { color: #409eff; }
.detail-card-row { background: #fff; border: 1px solid #ebeef5; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); padding: 12px 14px; margin-bottom: 12px; }
.detail-card-body { display: grid; gap: 8px; }
.detail-card-body.cols-4 { grid-template-columns: repeat(4, 1fr); }
.dc-cell { display: flex; justify-content: flex-start; align-items: center; gap: 8px; padding: 6px 10px; background: #f8f9fb; border-radius: 4px; }
.dc-cell.w4 { grid-column: span 4; }
.dc-cell.w2 { grid-column: span 2; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
/* 类型标签自定义色（金色 A / 紫色 C），与销售订单模块保持一致 */
::v-deep .el-tag.tag-vip-a {
  background-color: #fff1b8 !important;
  border-color: #faad14 !important;
  color: #874d00 !important;
  font-weight: 600 !important;
}
::v-deep .el-tag.tag-vip-c {
  background-color: #f4ecfb !important;
  border-color: #d3b4f1 !important;
  color: #722ed1 !important;
}
::v-deep .el-tag.tag-vip-b {
  background-color: #fff0f6 !important;
  border-color: #ff85c0 !important;
  color: #c41d7f !important;
}
::v-deep .el-tag.tag-newout {
  background-color: #e6fffb !important;
  border-color: #5cdbd3 !important;
  color: #08979c !important;
}
</style>
